<div class="main">
  <div class="section">
    <div class="head">
      <div class="label">
        {{'SHARE.mail_title' | translate}}
        <i class="material-icons" (click)="closeModal();">clear</i>
      </div>
    </div>
    <div class="body">
      <div class="inputContainer">
        <div class="label">
          {{'SHARE.mail_label' | translate}}
        </div>
        <input class="input"  type="text" [(ngModel)]="email" [placeholder]="'SHARE.placeholder' | translate">
      <div>
        <img src="assets/mailround.svg" alt="" (click)="sendEmail();">
      </div>
    </div>
    </div>
  </div>
</div>


  